import React from 'react';

interface ClientDetailNotesProps {
  notes: string | null;
}

const ClientDetailNotes: React.FC<ClientDetailNotesProps> = ({ notes }) => {
  if (!notes) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-3">
        Private Notes
      </h2>
      <p className="text-sm text-gray-700 whitespace-pre-wrap">{notes}</p>
    </div>
  );
};

export default ClientDetailNotes;
